import { Link } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useClientId } from "@/features/clients/detail/use-client-id";
import { SalesOrdersPage } from "@/features/sales-orders/sales-orders-page";

export function ClientOrdersPage() {
  const clientId = useClientId();
  return (
    <div className="space-y-3">
      <div className="flex justify-end">
        <Button asChild size="sm">
          <Link to="/sales-orders/new" search={{ client: clientId }}>
            <Plus />
            New order
          </Link>
        </Button>
      </div>
      <SalesOrdersPage clientId={clientId} embedded />
    </div>
  );
}
